import { useCallback, useState } from "react";
import {
  AndamentoCota,
  buscarAndamentosCotaService,
} from "../../../services/buscarAndamentosCotaService";

export const useBuscarAndamentosCota = () => {
  const [andamentos, setAndamentos] = useState<AndamentoCota[]>([]);
  const [loading, setLoading] = useState(false);

  const buscar = useCallback(async (cotaId: number) => {
    if (!cotaId) return;

    setLoading(true);
    try {
      const dados = await buscarAndamentosCotaService(cotaId);
      setAndamentos(dados);
    } catch (error) {
      console.error("Erro ao buscar andamentos da cota:", error);
      setAndamentos([]);
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    andamentos,
    loading,
    buscar,
  };
};
